var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectroicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000747681,
    width: 9.99931,
    height: 9.99931,
    rx: 4.99965,
    fill: "#FFF6E5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0004 0C2.23917 0 0.000747681 2.23842 0.000747681 4.99965C0.000747681 5.06662 0.00206438 5.13329 0.00467332 5.19962C0.109634 2.53108 2.30614 0.399922 5.0004 0.399922C7.69466 0.399922 9.89117 2.53108 9.99613 5.19962C9.99874 5.13329 10.0001 5.06662 10.0001 4.99965C10.0001 2.23842 7.76163 0 5.0004 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99966 9.99931C7.76089 9.99931 9.99931 7.76089 9.99931 4.99966C9.99931 4.93055 9.99791 4.86178 9.99513 4.79335C9.89343 7.46488 7.69557 9.59944 4.99916 9.59944C2.30703 9.59944 0.111871 7.47166 0.00368354 4.80609C0.00123832 4.87031 5.21112e-06 4.93484 5.20546e-06 4.99966C4.96406e-06 7.76089 2.23843 9.99931 4.99966 9.99931Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62512 1.87491L3.12529 5.26753H4.76578L4.37593 8.12453L6.87576 4.73191L5.23527 4.73191L5.62512 1.87491Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.00053,
    y1: 1.87491,
    x2: 5.00053,
    y2: 8.12453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectroicon);
export default __webpack_public_path__ + "static/media/electro icon.1e63532a08c82619be18f485b377a0f9.svg";
export { ForwardRef as ReactComponent };